// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StylePane_wrapper__3A8NN","paneTitle":"StylePane_paneTitle__1yAYF","themeButton":"StylePane_themeButton__3W0AB","lightText":"StylePane_lightText__6-umR"};